import { render } from "./Message.vue?vue&type=template&id=9f12c7f2"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__